module.exports = __webpack_public_path__ + "img/06.ea16a700.jpg";